module.exports = __webpack_public_path__ + "img/2.759bfe8c.png";